export default __webpack_public_path__ + "static/media/instagram.dd153900.png";